import { Link } from "react-router-dom";

export default function NTFooter() {
  return (
    <footer className="bg-[#1B1F5E]">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          
          {/* Logo + descrição */}
          <div className="lg:col-span-1">
            <div className="mb-5">
              <img
                src="https://i.ibb.co/v6yTBSFR/a4b787ad-8b62-4794-bdd2-2a6469c6a33f.png"
                alt="New Tech Solution"
                className="h-16 w-auto object-contain"
              />
            </div>

            <p className="text-white/60 text-sm leading-relaxed mb-5">
              Soluções industriais sob medida para máquinas especiais,
              automação e engenharia de alto desempenho.
            </p>

            <div className="flex items-center gap-3">
              {[
                "ri-instagram-line",
                "ri-linkedin-line",
                "ri-youtube-line",
                "ri-facebook-line",
              ].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-[#3FA7D6]/20 text-[#3FA7D6] hover:bg-[#3FA7D6] hover:text-white transition-all"
                >
                  <i className={`${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Empresa */}
          <div>
            <h4 className="font-rajdhani font-bold text-white text-sm uppercase tracking-wider mb-4">
              Empresa
            </h4>

            <ul className="space-y-2">
              {[
                "Sobre Nós",
                "Nossa História",
                "Missão e Valores",
                "Trabalhe Conosco",
              ].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="text-white/60 text-sm hover:text-[#3FA7D6]"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Soluções */}
          <div>
            <h4 className="font-rajdhani font-bold text-white text-sm uppercase tracking-wider mb-4">
              Soluções
            </h4>

            <ul className="space-y-2">
              {[
                "Automação Industrial",
                "Máquinas Especiais",
                "Acessórios Industriais",
                "Retrofit",
                "Engenharia de Projetos",
              ].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="text-white/60 text-sm hover:text-[#3FA7D6]"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Conteúdo */}
          <div>
            <h4 className="font-rajdhani font-bold text-white text-sm uppercase tracking-wider mb-4">
              Conteúdo
            </h4>

            <ul className="space-y-2">
              {[
                "Blog",
                "E-books",
                "Vídeos Técnicos",
              ].map((item) => (
                <li key={item}>
                  <a
                    href="#"
                    className="text-white/60 text-sm hover:text-[#3FA7D6]"
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h4 className="font-rajdhani font-bold text-white text-sm uppercase tracking-wider mb-4">
              Contato
            </h4>

            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-white/60 text-sm">
                <i className="ri-map-pin-line text-[#3FA7D6] mt-1"></i>

                Rua Gentile Schimitt, 320,
                Bairro Santa Terezinha
                <br />
                Gaspar, SC – 89114-395
              </li>

              <li className="flex items-center gap-2 text-white/60 text-sm">
                <i className="ri-phone-line text-[#3FA7D6]"></i>

                +55 (47) 9774-0084
              </li>

              <li className="flex items-center gap-2 text-white/60 text-sm">
                <i className="ri-mail-line text-[#3FA7D6]"></i>

                contato@newtechsolution.com.br
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            © 2025 New Tech Solution.
            Todos os direitos reservados.
          </p>

          <div className="flex items-center gap-4 flex-wrap justify-center">
            {[
              "HOME",
              "SOBRE",
              "SERVIÇOS",
              "PRODUTOS",
              "CONTATO",
            ].map((item) => (
              <a
                key={item}
                href="#"
                className="text-white/40 text-xs hover:text-[#3FA7D6] whitespace-nowrap hidden lg:block"
              >
                {item}
              </a>
            ))}

            <Link
              to="/admin"
              className="text-white/30 text-xs hover:text-white/60"
            >
              Área Admin
            </Link>
          </div>
        </div>

        <div className="border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 py-4 text-center">
            <p className="text-white/40 text-xs">
              Orgulhosamente desenvolvido por{" "}
              <a
                href="https://www.serraconsultoria.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#3FA7D6] hover:text-white transition-colors font-semibold"
              >
                Serra Consultoria
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
